import { Component, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { AsyncPipe } from '@angular/common';

export class Tab {
  constructor(public label: string, public path: string, public id: string, public isVisible$: Observable<boolean> = of(true)) { }
}

@Component({
  selector: 'lc-navigation-tabs',
  templateUrl: './navigation-tabs.component.html',
  styleUrls: ['./navigation-tabs.component.scss'],
  host: { class: 'mat-elevation-z1 border p-xl d-block border-radius-4' },
  imports: [
    MatTabNav,
    MatTabLink,
    RouterLink,
    MatDivider,
    MatTabNavPanel,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class NavigationTabsComponent {
  @Input()
    tabs: Tab[];

  @Input()
    activeId: string;
}
